<template>
          <transition name="fade">
    <v-flex class="pagina-curso" xs12 fill-height>
        <div class="contenido">
          <v-layout row wrap justify-center align-center>
            <v-flex xs9 sm7 md7 mt-4 class="cont-logo-ibraco animated fadeInDown dura-2">
                <img src="@/assets/imagenes_compartidas/Logo_Simple_IBRACO_aaa.svg" alt="IBRACO">
            </v-flex >
            <v-flex xs12 sm7 md7 mt-3>
              <dialogos-app 
              :dialogos="dialogos" 
              tucan="0" class="mostrar-dialogo"
              diagCenter></dialogos-app>
            </v-flex>
            <!-- contenido en vista para movil -->
            <v-layout justify-center align-center row wrap class="cont-web">
              <v-flex xs10 sm7 md7 text-xs-center class="titulo animated fadeInUp dura-3">
                <p>Bem-vindo ao curso virtual do IBRACO!</p>
              </v-flex>
              <v-layout justify-center row wrap class="cont-boton">
                <v-flex xs12 md8 text-xs-center mt-5 pt-3 class="subtitulo">
                  <p class="animated fadeIn dura-4">O Brasil é AQUI!</p>
                  <router-link to="/presentacion/0">
                  <div class="animated bounceInUp dura-5">
                    <button class="btn_inicio hvr-scale"><span>Começar</span></button>
                  </div>
                  </router-link>
                </v-flex>
              </v-layout>
            </v-layout>
          </v-layout>
        </div>
        <div class="fondo_main">
          <div class="display_fondo"></div>
        </div>
    </v-flex>
          </transition>
</template>

<script>
 export default {
    data(){
    return {
      dialogos:[
        'Bem-vindo ao curso vistual do IBRACO! O Brasil é AQUI!. <br> Clique em começar.'
      ],
      isActive: true,
      windowSize: {
          x: 0,
          y: 0,
        }
      }
    },
    mounted () {
      this.onResize()
    },
    methods: {
      onResize () {
        this.windowSize = { x: window.innerWidth, y: window.innerHeight }
        if(window.innerWidth == 360 && window.innerHeight == 640 ){
            console.log("estoy en width 360")
        }
      },
    },
  }

</script>
<style lang="scss" scoped> 
@import "../sass/globals";
.pagina-curso {
  background: url("../assets/fondo/Fondo_Web_optimizado.svg")no-repeat;
  background-position:bottom;
  background-size:contain;
  height: auto;
  max-height: 100vh;
  overflow-y: auto;
  .contenido {
    max-width: 100%;
    width: 1100px;
    margin: auto;
    position: relative;
    overflow: hidden;
    min-height: calc(100vh - 60px);
    height: auto;
    padding: 10px;
    margin-top: 60px;

    }
  }
  .mostrar-dialogo{
      @media (max-width: 600px) {
     display: none;
    }
  }
  .cont-boton{
    background: url("../assets/fondo/Fondo_movil_optimo.svg")no-repeat;
    background-size: cover;
    height: 70vh;
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
  }
  .cont-web{
    @media (min-width: 600px) {
     display: none;
     position: relative;
    }
  }

  .cont-logo-ibraco{
    text-align: center;
    img{
      width: 80%;
    }
    @media only screen and (orientation: landscape) and (max-width: 800px){
        text-align: center;
        img{
        width: 70%;
      }
    }
  }
.titulo{
  font-family: Poppins-Bold;
  font-size: 20px;
  color:$ibra-dark-blue;
}
.subtitulo{
  font-family: Poppins-Bold;
  font-size: 20px;
  color:#FFF;
}
.btn_inicio{
  background: #F8C300;
  font-family: Poppins-Bold;
  font-size: 25px;
  color:$ibra-dark-blue;
  border-radius: 4px;
  padding: 10px 20px;
  p{
    margin: 0;
    padding: 0;

  }
}

.fade-enter-active, .fade-leave-active {
    transition: all 2s;
    position: absolute;
    max-height: 100%;
    min-height: 100%;
    overflow: hidden;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>

